//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        name: 'maternal_form_d',
        data(){
            return{
                showSignature:false,
                form:{
                    room_number:'',
                    mom_name:'',
                    delivery_type:'',
                    cat_date:'',
                    diet:'',
                    // diet_ordinary:'',
                    // diet_special:'',
                    sleep_time:'8',
                    urine_num:'6',
                    shit_num:'1',
                    wash_brush:'3',
                    wash_hair:'0',
                    wash_bath:'1',
                    wash_clean:'3',
                    sport_time:'20',
                    // sport_assess:'',
                    sport:'1',
                    sport_text:'',
                    // other_case:'',
                    guiding_pinions:'',
                    autograph:'',
                    shifts:''
                },
                option:{
                    penColor:"rgb(0, 0, 0)"
                },
                get_host:host.host
            }
        },
        methods:{
            //请求用户基本信息
            apiMemberInfo(){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.checkRoomApi.memberInfo(params).then ( res => {
                    console.info('请求用户基本信息',res)
                    if(res.errcode == 1){
                        this.form.delivery_type = res.data.birth_type == '1' ? '经阴道' : res.data.birth_type == '2' ? '剖宫产' : res.data.birth_type == '3' ? '小产' : ''
                        this.form.mom_name = res.data.name
                        this.form.room_number = res.data.room_name
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            // 保存
             save(){
                let signature ='signature1'
                let png = this.$refs[signature].save()
                this.form.autograph = encodeURI(png)
                this.showSignature = true
            },
            //编辑
            edit(){
                this.showSignature = false
                this.form.autograph = ''
            },
            //清除
            clear(){
                let signature ='signature1'
                let refs = this.$refs[signature].clear()
                this.form.autograph = ''
            },
            //请求详情数据
            apiDetail(){
                let params = {
                    token: this.$cookie.get('token'),
                    id:this.$route.query.list_id
                }
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.bbFormApi.getMaternalEverydayPhysiologyFind(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        let data = res.data
                        this.form.room_number = data.room_number
                        this.form.mom_name = data.mom_name
                        this.form.delivery_type = data.delivery_type
                        this.form.cat_date = data.cat_date
                        this.form.diet = data.diet
                        // this.form.diet_ordinary = data.diet_ordinary
                        // this.form.diet_special = data.diet_special
                        this.form.sleep_time = data.sleep_time
                        this.form.urine_num = data.urine_num
                        this.form.shit_num = data.shit_num
                        this.form.wash_brush = data.wash_brush
                        this.form.wash_hair = data.wash_hair
                        this.form.wash_bath = data.wash_bath
                        this.form.wash_clean = data.wash_clean
                        this.form.sport_time = data.sport_time
                        // this.form.sport_assess = data.sport_assess
                        this.form.sport = data.sport
                        this.form.sport_text = data.sport_text
                        // this.form.other_case = data.other_case
                        this.form.guiding_pinions = data.guiding_pinions
                        this.form.autograph = data.autograph.indexOf(this.get_host) != -1 ? data.autograph : this.get_host+data.autograph
                        this.form.shifts = data.shifts
                        this.showSignature = true
                        this.$vux.loading.hide()
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //请求添加数据
            apiAddForm(){
                let params = {
                    token: this.$cookie.get('token'),
                    number_id:this.$cookie.get('id'),
                    maternal_info_id: this.$route.query.id,
                    store_id:this.$cookie.get('store_id'),
                    room_number:this.form.room_number,
                    mom_name:this.form.mom_name,
                    delivery_type:this.form.delivery_type,
                    cat_date:this.form.cat_date,
                    diet:this.form.diet,
                    // diet_ordinary:this.form.diet_ordinary,
                    // diet_special:this.form.diet_special,
                    sleep_time:this.form.sleep_time,
                    urine_num:this.form.urine_num,
                    shit_num:this.form.shit_num,
                    wash_brush:this.form.wash_brush,
                    wash_hair:this.form.wash_hair,
                    wash_bath:this.form.wash_bath,
                    wash_clean:this.form.wash_clean,
                    sport_time:this.form.sport_time,
                    // sport_assess:this.form.sport_assess,
                    sport:this.form.sport,
                    sport_text:this.form.sport_text,
                    // other_case:this.form.other_case,
                    guiding_pinions:this.form.guiding_pinions,
                    autograph:this.form.autograph,
                    shifts: this.form.shifts
                }
                console.info(params)
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.bbFormApi.addMaternalEverydayPhysiology(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        this.$vux.loading.hide()
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal:this.$route.query.tabVal,
                                name : 'maternal_form_d',
                            }
                        })
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            // 请求更新数据
            apiUpdateForm(){
                let params = {
                    token: this.$cookie.get('token'),
                    id:this.$route.query.list_id,
                    number_id:this.$cookie.get('id'),
                    maternal_info_id: this.$route.query.id,
                    store_id:this.$cookie.get('store_id'),
                    room_number:this.form.room_number,
                    mom_name:this.form.mom_name,
                    delivery_type:this.form.delivery_type,
                    cat_date:this.form.cat_date,
                    diet:this.form.diet,
                    sleep_time:this.form.sleep_time,
                    urine_num:this.form.urine_num,
                    shit_num:this.form.shit_num,
                    wash_brush:this.form.wash_brush,
                    wash_hair:this.form.wash_hair,
                    wash_bath:this.form.wash_bath,
                    wash_clean:this.form.wash_clean,
                    sport_time:this.form.sport_time,
                    // sport_assess:this.form.sport_assess,
                    sport:this.form.sport,
                    sport_text:this.form.sport_text,
                    // other_case:this.form.other_case,
                    guiding_pinions:this.form.guiding_pinions,
                    autograph:this.form.autograph.indexOf(this.get_host) != -1 ? this.form.autograph.replace(this.get_host,'') : this.form.autograph,
                    shifts: this.form.shifts
                }
                console.info(params)
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.bbFormApi.updateMaternalEverydayPhysiology(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        this.$vux.loading.hide()
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal:this.$route.query.tabVal,
                                name : 'maternal_form_d',
                            }
                        })
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            submitForm(){
                let form = this.form
                if(form.delivery_type == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择分娩方式',
                    })
                    return
                }
                if(form.cat_date == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择日期',
                    })
                    return
                }
                if(form.diet == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择饮食',
                    })
                    return
                }
                if(form.sleep_time == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入睡眠',
                    })
                    return
                }
                if(form.urine_num == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入小便',
                    })
                    return
                }
                if(form.shit_num == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入大便',
                    })
                    return
                }
                if(form.wash_brush == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入刷牙',
                    })
                    return
                }
                if(form.wash_hair == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入洗头',
                    })
                    return
                }
                if(form.wash_bath == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入沐浴',
                    })
                    return
                }
                if(form.wash_clean == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入会阴清洁',
                    })
                    return
                }
                if(form.sport_time == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入运动时间',
                    })
                    return
                }
                if(form.sport == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择运动后评估',
                    })
                    return
                }
                if(form.guiding_pinions == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入指导意见',
                    })
                    return
                }
                if(form.autograph == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入签名',
                    })
                    return
                }
                if(form.shifts == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择班次',
                    })
                    return
                }

                if(this.$route.query.list_id){
                    console.info("请求更新数据")
                    this.apiUpdateForm()
                }else{
                    console.info("请求添加数据")
                    this.apiAddForm()
                }
            }
        },
        mounted(){
            if(this.$route.query.list_id){
                this.apiDetail()
            }else{
                this.apiMemberInfo()
                this.form.guiding_pinions='母乳喂养、母婴同室'
            }
        }
    }



// WEBPACK FOOTER //
// ./src/components/maternal_form_d.vue